import { combineReducers } from 'redux';
import appMarketReducer from './appMarket';
import myAppReducer from './myApp';
import appLearnMoreReducer from './appLearnMore';

export { appMarketReducer, myAppReducer, appLearnMoreReducer };

export default combineReducers({
  appMarket: appMarketReducer,
  myApp: myAppReducer,
  appLearnMore: appLearnMoreReducer,
});
